import { useEffect } from "react";
import type { HttpAgent } from "@ag-ui/client";

const SKILL_TOOL_NAMES = new Set(["create_skill", "update_skill", "delete_skill"]);

/**
 * Subscribes to AG-UI tool call events from the agent and triggers a skills
 * refresh whenever the backend agent completes a create_skill, update_skill,
 * or delete_skill tool call. This keeps the skills dropdown in sync when the
 * agent autonomously modifies skills during a conversation.
 */
export function useSkillSync(agent: HttpAgent, refreshSkills: () => Promise<void>) {
  useEffect(() => {
    const sub = agent.subscribe({
      onToolCallEndEvent: ({ toolCallName }) => {
        if (SKILL_TOOL_NAMES.has(toolCallName)) {
          refreshSkills().catch((err) =>
            console.error("[useSkillSync] Failed to refresh skills:", err)
          );
        }
      },
    });

    return () => sub.unsubscribe();
  }, [agent, refreshSkills]);
}
